// extracted by mini-css-extract-plugin
module.exports = {"basketOuter":"shoppingBasket_basketOuter__3gSPp","basket":"shoppingBasket_basket__1w2cR","item":"shoppingBasket_item__1NFc-","quantity":"shoppingBasket_quantity__2Mz1p"};